import { render, staticRenderFns } from "./AdminUtilityReimbursementFailureDetail.vue?vue&type=template&id=49a88d27"
import script from "./AdminUtilityReimbursementFailureDetail.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityReimbursementFailureDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports